import { Tooltip } from '@maxtropy/components';
import styles from './index.module.scss';
import dayjs from 'dayjs';

interface DataList {
  ts: number;
  flag: boolean;
}

interface TimeAxisProps {
  pageLabel?: string;
  data?: DataList[];
}

const TimeAxis = ({ pageLabel, data = [] }: TimeAxisProps) => {
  const startLabel = data[0]?.ts ? dayjs(data[0].ts).format('MM-DD') : '--';
  const endLabel = data[data.length - 1]?.ts ? dayjs(data[data.length - 1].ts).format('MM-DD') : '--';

  return (
    <div className={styles.itemContent}>
      <div className={styles.statusBar}>
        {data.map((detail, index) => (
          <Tooltip
            key={index}
            placement="top"
            getPopupContainer={trigger => trigger.parentElement || document.body}
            title={
              <>
                {dayjs(detail.ts).format('YYYY-MM-DD')}{' '}
                <span style={{ color: detail.flag ? '#ff9247' : 'inherit' }}>
                  {detail.flag ? pageLabel : `非${pageLabel}`}
                </span>
              </>
            }
          >
            <div className={`${styles.statusBlock} ${detail.flag ? styles.active : styles.inactive}`} />
          </Tooltip>
        ))}
      </div>
      <div className={styles.timeLabel}>
        <span>{startLabel}</span>
        <span>{endLabel}</span>
      </div>
    </div>
  );
};

export default TimeAxis;
